import { uploader } from '@gem/modules/file-upload';
import { t } from '@gem/modules/i18n';

import Tasks from 'APP/Tasks';
import Entities from 'STORE';

interface ICreateStreamData {
  groupId: string;
  preview: File | null;
  title: string | null;
}

export async function createStream(data: ICreateStreamData): Promise<boolean> {
  let previewImageUrl: string | null = null;
  if (data.preview) {
    try {
      const { uploadUrl, publicUrl, headers } = await uploader.getUploadUrlData(
        data.preview.name,
        data.preview.type
      );

      if (!uploadUrl) {
        throw new Error('uploadUrl not received');
      }
      await uploader.uploadFile(uploadUrl, data.preview, data.preview.name, headers);
      previewImageUrl = publicUrl;
    } catch {
      const canUpload = await Tasks.app.showConfirm({
        title: t('uploading_thumbnail_error_title'),
        text: t('uploading_thumbnail_error'),
        primaryText: t('next_button'),
      });

      if (!canUpload) {
        return false;
      }
    }
  }

  Entities.ActiveStream.createStream({
    groupId: data.groupId,
    title: data.title,
    previewImageUrl,
  });

  return true;
}
